define(function (require) {
    const tpl = require('./t_lov_create_log.hbs');
    const log_model = require('civicsModels/log_model');
    const instrument_model = require('civicsModels/instrument_model');
    const ViewManager = require('civicsUtils/view_manager');
    const utils = require('civicsUtils/general_utilities');
    return Marionette.LayoutView.extend({
        className: 'create-log',
        template:tpl,
        regions: {},
        events: {
            'click @ui.cancelButton':'onCancelClicked',
            'click @ui.closeButton':'onCancelClicked',
            'click @ui.submitButton':'submitClicked',
        },
        ui: {
            comments:'#newlink-description',
            commentsSection:'.field-description',
            cancelButton:'.cancel-button',
            closeButton:'.bbm-btn-close',
            submitButton:'.submit-button',
        },
        childEvents: {},
        views: {},

        initialize: function (options) {
            this.config = options.config;
            this.title = options.title;
            this.instructions = options.instructions;
            this.type = options.type;
            this.instrumentType = options.instrumentType;
            this.instrumentID = options.instrumentID;
            this.parentView = options.parentView;
            this.preText = (options.preText) ? options.preText:'';
            this.canUpdateStatus = options.canUpdateStatus;
            this.modalRegion = options.modalRegion;
            this.submitButtonText = options.submitButtonText;
            this.cancelButtonText = options.cancelButtonText;
            this.statusCode = options.statusCode;
            this.allowComments = options.allowComments === undefined || options.allowComments === null ? true : options.allowComments;
        },
        onShow:function(){
          if (!this.allowComments) {
            $(this.ui.commentsSection).remove();
          }
          else {
            $(this.ui.comments).maxlength();
          }
        },
        onRender:function(){
            this.$el.rhythmThemeInit();
        },
        onCancelClicked:function() {
            if(this.modalRegion) {
                this.modalRegion.hideModal();
            }
            else {
                this.destroy();
            }
        },
        submitClicked:function(){
            ViewManager.loading(true);
            var model = new log_model();
            model.instrumentType = this.instrumentType;
            if(this.instrumentType.toLowerCase() == 'servicerequest'){
                model.set({
                    type: { code: this.type },
                    start:utils.dateTimeStringFromDate(new Date()), //isoFixed
                    comments:this.preText+this.ui.comments.val(),
                    application:this.instrumentID
                });
            } else {
                model.set({
                    logType:this.type,
                    startDateTime:utils.dateTimeStringFromDate(new Date()), //isoFixed
                    comments:this.preText+this.ui.comments.val(),
                    application:this.instrumentID
                });
            }
            model.save(null,{
                success:function(r,m,o){
                    ViewManager.loading(false);
                    ViewManager.broadcast(this,'saved');

                    this.createdLog();

                    if(this.modalRegion) {
                        this.modalRegion.hideModal();
                    }
                    else {
                        this.destroy();
                    }

                }.bind(this),
                error: function(model, response, options){
                    ViewManager.loading(false);
                    ViewManager.errorToWindow(response, this);
                }
            })
        },
        createdLog: function() {
          if (this.canUpdateStatus && this.statusCode != null && this.statusCode.trim() != "") {
            ViewManager.loading(true);
          
              var instrumentModel = new instrument_model();
              instrumentModel.set('id', this.instrumentID);
              instrumentModel.set('status', this.statusCode);
              instrumentModel.instrumentType = this.instrumentType;
              instrumentModel.save(null, {
                success: function() {
                  window.location.reload(true);
                },
                error: function() {
                  if (__DEV__) {
                    console.log('error saving withdrawal status')
                  } else {
                    window.location.reload(true);
                  }
                }
              });


          } else {
            window.location.reload(true);
          }
        },
        templateHelpers:function(){
            return{
                title:this.title,
                instructions:this.instructions,
                submitButtonText: this.submitButtonText ? this.submitButtonText : i18n.t('CIVICS.COMMON.SUBMIT'),
                cancelButtonText: this.cancelButtonText ? this.cancelButtonText : i18n.t('CIVICS.COMMON.CANCEL')
            }
        }
    });
});
